import RevenueRecognition from './revenueRecognition';
import ExpenseRecognition from './expenseRecognition';
import RevenueExpense from './revenueExpense';
import AssumptionsPrinciplesConstraints from './assumptionsPrinciplesConstraints';

const levelComponents = {
  'revenue-recognition': RevenueRecognition,
  'expense-recognition': ExpenseRecognition,
  'revenue-expense': RevenueExpense,
  'assumptions-principles-constraints': AssumptionsPrinciplesConstraints
};

export default function ThePrinciples({
  levelType,
  onComplete,
  numberOfAttempts
}) {
  const Component = levelComponents[levelType] || RevenueRecognition;

  return (
    <Component
      onComplete={onComplete}
      numberOfAttempts={numberOfAttempts}
    />
  );
}